export const BLOCK_NAVIGATION = 'BLOCK_NAVIGATION';
export const ALLOW_NAVIGATION = 'ALLOW_NAVIGATION';
